/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2018 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

import { EXTERNAL_TYPE, SIGN_TYPE } from "constants/constants";

/**
 * Utility to check if the asset is a external asset or not.
 */
export const isExternalAsset = assetType => assetType && assetType === EXTERNAL_TYPE;

/**
 * Utility to check if the asset is a sign asset or not.
 */
export const isSignAsset = assetType => assetType && assetType === SIGN_TYPE;
